import React from "react";
import Navbar from "./Navbar";
import avatar from "../images/avatar.png";
import Header from "./Header";
const About = () => {
  return (
    <>
      <Navbar name={"About"} />
      <div
        style={{
          left: "50%",
          top: "50%",
          transform: "translate(-50%,-50%)",
          position: "absolute",
        }}
      >
        <img src={avatar} height="300px" width="auto" alt="" />
        <Header />
        <h1 style={{ color: "white", textAlign: "center", fontSize: "2.5rem" }}>
          NIKHIL TRIPATHI
        </h1>
      </div>
    </>
  );
};

export default About;
